import { render, staticRenderFns } from "./SupplierDetailsModal.vue?vue&type=template&id=3aa41a8c&"
import script from "./SupplierDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports